/**
 * Ryan O'Dowd
 * 2024-05-13
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'center',
      color: colors.primaryDark,
      padding: 6,
      borderRadius: 8,
    },
  };
};

export default getStyles;
